import StrategicAccounts from './data/StrategicAccounts.json';

const getAllOrgIdsFromUserVenues = userVenues => {
  return userVenues.reduce((acc, { organizationId }) => [...acc, organizationId], []);
};

export const isStrategicAccount = userVenues => {
  const orgIds = getAllOrgIdsFromUserVenues(userVenues);
  let orgIdFound = false;
  orgIds.forEach(id => {
    if (StrategicAccounts.orgIds.indexOf(id) !== -1) {
      orgIdFound = true;
    }
  });

  return orgIdFound;
};
